// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3XNFm","rightAdornment":"Header_rightAdornment__3eFFO"};